"use strict";
module.exports = {
    _extensions: {},
};
//# sourceMappingURL=module-with-extensions.js.map